<template>
  <button
    class="app-btn"
    :class="`app-btn--${variant}`"
    :disabled="disabled"
    @click="$emit('click', $event)"
  ><slot></slot></button>
</template>

<script>
export default {
  name: 'app-button',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: (v) => ['primary', 'ghost', 'text'].includes(v),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.app-btn {
  appearance: none;
  border: none;
  border-radius: var(--radius);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 10px 18px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  transition: box-shadow 200ms ease, background-color 150ms ease, transform 80ms ease;
}
.app-btn:active { transform: translateY(1px); }
.app-btn:focus-visible { outline: 2px solid var(--brand-dark); outline-offset: 2px; }

.app-btn--primary {
  background: var(--brand);
  color: var(--brand-ink);
  box-shadow: var(--shadow-raised);
}
.app-btn--primary:hover:not(:disabled) {
  background: var(--brand-dark);
  box-shadow: var(--shadow-raised-hover);
}

.app-btn--ghost { background: transparent; color: var(--brand-dark); }
.app-btn--ghost:hover:not(:disabled) { background: var(--brand-soft); }

.app-btn--text {
  background: transparent;
  color: var(--brand-dark);
  padding: 7px 10px;
  text-transform: none;
  font-weight: 650;
  letter-spacing: 0;
}
.app-btn--text:hover:not(:disabled) { background: var(--brand-soft); }

.app-btn:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }
</style>
